import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { updateParamFilterType } from 'actions/assign';

class Filter extends PureComponent {
  constructor(props) {
    super(props);
    this.selectedOptions = new Set(props.selectedOptions);
    this.hasAllOptions = this.selectedOptions.size === props.options.length;
    this.handleChange = this.handleChange.bind(this);
    this.renderOption = this.renderOption.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.selectedOptions = new Set(nextProps.selectedOptions);
  }

  handleChange(e) {
    const { value } = e.target;
    if (this.selectedOptions.has(value)) {
      this.selectedOptions.delete(value);
    } else {
      this.selectedOptions.add(value);
    }
    this.props.updateFilterType(Array.from(this.selectedOptions));
  }

  renderOption({ value, label }) {
    const isChecked = this.selectedOptions.has(value);
    const className = classNames('Pill', {
      'Pill--selected': isChecked,
      'Pill--clickable': true,
    });

    return (
      <label key={value} htmlFor={value} className={className}>
        <input
          id={value}
          type="checkbox"
          value={value}
          onChange={this.handleChange}
          defaultChecked={isChecked}
        />
        {label}
      </label>
    );
  }

  render() {
    const { options } = this.props;
    return (
      <div className="AssignModal-typePills">
        {options.map(this.renderOption)}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  selectedOptions: state.params.filter.type,
  hasResourceExperiment: state.meta.features.resource_experiment,
});

const mapDispatchToProps = dispatch => ({
  updateFilterType(values) {
    dispatch(updateParamFilterType(values));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Filter);
